import * as React from "react";
import { StyleProp, StyleSheet, ViewStyle } from "react-native";

import { View } from "../../components/Themed";
import { Move } from "../../types";

import MoveForm, { MoveFormProps } from "./MoveForm";

import commonStyles from "../../styles/common";

export interface MoveListItemProps extends Pick<MoveFormProps, "onSave"> {
  style?: StyleProp<ViewStyle>;
  move: Move;
  disabled?: boolean;
}

function MoveListItem({ move, style, onSave, disabled }: MoveListItemProps) {
  return (
    <View style={[style, commonStyles.gridItem]}>
      <MoveForm
        onSave={onSave}
        move={move}
        style={commonStyles.listItemPrimary}
        disabled={disabled}
      />
    </View>
  );
}

const styles = StyleSheet.create({});

export default MoveListItem;
